__turbopack_context__.v({
  "tab": "Content-module-scss-module__U7hI4G__tab",
  "tabs": "Content-module-scss-module__U7hI4G__tabs",
  "tabsWrapper": "Content-module-scss-module__U7hI4G__tabsWrapper",
});
